import { CSSObject } from '@chakra-ui/react';

export const BoxWrapper: CSSObject = { bg: 'transparent', h: 'full' };

export const ButtonDropdown: CSSObject = {
  bg: 'linear-gradient(180deg, rgba(104, 219, 255, 0.80) 0%, rgba(26, 200, 255, 0.80) 100%)',
  border: 'none',
  color: 'white',
  h: 'full',
  fontSize: '10px',
  textShadow: '0px 2px 1px rgba(0, 0, 0, 0.15)',
  px: '1.5',
  borderRadius: '5px',
  w: '107px',

  _hover: {
    bg: 'linear-gradient(180deg, rgba(104, 219, 255, 0.80) 0%, rgba(26, 200, 255, 0.80) 100%)',
  },

  '*': {
    transition: 'all .2s ease-in-out',
  },

  svg: {
    pos: 'relative',
    top: '-1px',
  },

  '&[aria-expanded="true"]': {
    svg: {
      transform: 'rotate(180deg)',
    },
  },
};
export const BoxDropdown: CSSObject = {
  bg: 'linear-gradient(180deg, #51D0F7 0%, #37BAE3 100%)',
  color: 'gamma.900',
  zIndex: 'docked',
  h: 'full',
  borderRadius: '5px',
  boxShadow: '0px 2px 5px 0px rgba(0, 0, 0, 0.35)',
  border: '2px solid rgba(255, 255, 255, 0.80)',
};
export const TextTitle: CSSObject = {
  color: 'gamma.900',
};
